import * as ActionType from './actionTypes';

export function setScrollPosition(scrollPosition) {
  return {
    type: ActionType.SET_SCROLL_POSITION,
    scrollPosition
  }
}

export function setPage(page) {
  return {
    type: ActionType.SET_PAGE,
    page
  }
}

export function setAnswer(key, answer) {
  return {
    type: ActionType.SET_ANSWER,
    key,
    answer
  }
}

export function toggleMenu(menu) {
  return {
    type: ActionType.SET_MENU,
    menu
  }
}

export function reset() {
  return {
    type: ActionType.RESET
  }
}

export function showMore() {
  return {
    type: ActionType.SHOW_MORE,
    mobileMore: true
  }
}
